@if (!invitationBlocked) {
<div class="registration-input-container" data-registration-form>
  <div class="personal">
    <h5 class="viz-h5">Personal Information</h5>
    <div>
      <mat-form-field [formGroup]="formGroup" class="form-field">
        <mat-label data-first-name-label>First Name</mat-label>
        <input matInput
          data-first-name-input
          id="first-name-input"
          formControlName="firstName">
        @if (hasRequiredError('firstName')) {
          <mat-error data-first-name-required
            >First Name is Required
          </mat-error>
        }
        @if (isInvalid('firstName')) {
          <mat-error data-first-name-invalid
            id="first-name-invalid-error"
            >Invalid First Name
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field [formGroup]="formGroup" class="form-field">
        <mat-label data-last-name-label>Last Name</mat-label>
        <input matInput
          data-last-name-input
          id="last-name-input"
          formControlName="lastName">
        @if (hasRequiredError('lastName')) {
          <mat-error data-last-name-required
            >Last Name is Required
          </mat-error>
        }
        @if (isInvalid('lastName')) {
          <mat-error data-last-name-invalid id="last-name-invalid-error"
            >Invalid Last Name
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field [formGroup]="formGroup" class="form-field">
        <mat-label data-email-label>Email</mat-label>
        <input matInput
          type="email"
          id="email-input"
          formControlName="email"
          data-email-input>
        @if (hasRequiredError('email')) {
          <mat-error data-email-required
            >Email is Required
          </mat-error>
        }
        @if (isInvalid('email')) {
          <mat-error data-email-invalid
            >Invalid Email
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="password">
    <div class="registration-captcha-spacing">
      <button mat-flat-button
        data-confirm-button
        [disabled]="!enabled"
        (click)="Register()"
        class="request-login-button">
        Request Login
      </button>
    </div>
  </div>
</div>
}
